export default {
  namespaced: true,
  state: {
    config: null,
  },
  mutations: {

  },
  getters: {

  },
  actions: {
    /**
     * [get_config description]
     * @param  {[type]} options.commit  [description]
     * @param  {[type]} options.getters [description]
     * @return {[type]}                 [description]
     */
    get_config({commit, getters}) {
      return this._vm.$http.get('membership/config')
        .then(response => response.data)
    }
  }
}